import { JOBS_STORAGE_KEY, JOBS_UPDATED_EVENT } from '@/constants';

export const loadJobsFromStorage = (): { jobId: string; date: string }[] => {
    const jobs = localStorage.getItem(JOBS_STORAGE_KEY);
    return jobs ? JSON.parse(jobs) : [];
};

export const saveJobsToStorage = (jobs: { jobId: string; date: string }[]) => {
    localStorage.setItem(JOBS_STORAGE_KEY, JSON.stringify(jobs));
    window.dispatchEvent(new Event(JOBS_UPDATED_EVENT));
};

export const addJobToStorage = (jobId: string) => {
    const jobs = loadJobsFromStorage();
    jobs.push({ jobId, date: new Date().toISOString() });
    saveJobsToStorage(jobs);
};

export const clearOldJobsFromStorage = (days: number) => {
    const DAYS_MS = days * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();

    const jobs = loadJobsFromStorage().filter(job => now - new Date(job.date).getTime() <= DAYS_MS);

    saveJobsToStorage(jobs);
};
